import { ICarePlanGoalsStore } from './types';

const initStore: ICarePlanGoalsStore = {
  items: [],
};

export default initStore;
